document.addEventListener('DOMContentLoaded', function() {
  let isLoading = false;
  let currentPage = 1;

  window.onscroll = function() {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && !isLoading) {
      isLoading = true;
      currentPage++;

      fetch(`?page=${currentPage}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('.product-grid-item');
          if (newProducts.length > 0) {
            const productContainer = document.querySelector('.product-grid');
            newProducts.forEach(product => productContainer.appendChild(product));
            isLoading = false;
          } else {
            // No more products to load
            window.onscroll = null;
          }
        });
    }
  };
});